webpackJsonp([222457311475995],{

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _tom = __webpack_require__(137);
	
	var _tom2 = _interopRequireDefault(_tom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Profile = function Profile() {
	  return _react2.default.createElement('img', { className: 'img-fluid rounded-circle', src: _tom2.default });
	};
	
	exports.default = Profile;
	module.exports = exports['default'];

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tom.8773dd12.jpg";

/***/ }),

/***/ 489:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iNTRmY2MyZjctNTNlNy00NWQ4LWE4NDEtZGM3ZDE0NTA1ZmViIiBkYXRhLW5hbWU9IkxheWVyIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIxMDM4Ljg3IiBoZWlnaHQ9IjgxMC40NyIgdmlld0JveD0iMCAwIDEwMzguODcgODEwLjQ3Ij48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9IjI3NDY1ZjI1LTk0MDgtNDlhOS05MjE2LTQ4YTZjZTljNzBhOCIgeDE9IjUzNC45MiIgeTE9IjgxMC40NyIgeDI9IjUzNC45MiIgeTI9IjIyMi40NyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iZ3JheSIgc3RvcC1vcGFjaXR5PSIwLjI1Ii8+PHN0b3Agb2Zmc2V0PSIwLjU0IiBzdG9wLWNvbG9yPSJncmF5IiBzdG9wLW9wYWNpdHk9IjAuMTIiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9ImdyYXkiIHN0b3Atb3BhY2l0eT0iMC4xIi8+PC9saW5lYXJHcmFkaWVudD48bGluZWFyR3JhZGllbnQgaWQ9ImU5MTA0MmNiLTI0ZWEtNDViNy1iMTE0LTZiMWQwNGJiN2YwOCIgeDE9IjcxNy40MiIgeTE9IjI5NC40NyIgeDI9IjcxNy40MiIgeTI9IjIzMC40NyIgeGxpbms6aHJlZj0iIzI3NDY1ZjI1LTk0MDgtNDlhOS05MjE2LTQ4YTZjZTljNzBhOCIvPjxsaW5lYXJHcmFkaWVudCBpZD0iOWNmOGUwOTgtNmZhZi00YTczLWI4MzEtYmE0MmJhMDkyZjBjIiB4MT0iMzk1LjQyIiB5MT0iMzk3LjQ3IiB4Mj0iMzk1LjQyIiB5Mj0iMzI5LjQ3IiB4bGluazpocmVmPSIjMjc0NjVmMjUtOTQwOC00OWE5LTkyMTYtNDhhNmNlOWM3MGE4Ii8+PGxpbmVhckdyYWRpZW50IGlkPSIyMWJjYzNlNC1jZDA1LTRkMmUtYjk1ZC05YzJjYmY4OTBhNTgiIHgxPSIzOTUuNDIiIHkxPSI1MzUuNDciIHgyPSIzOTUuNDIiIHkyPSI0NjcuNDciIHhsaW5rOmhyZWY9IiMyNzQ2NWYyNS05NDA4LTQ5YTktOTIxNi00OGE2Y2U5YzcwYTgiLz48bGluZWFyR3JhZGllbnQgaWQ9IjRkODUzYWZlLWNkY2MtNDg1OC1hOTAwLTgyMGI1MzU3NDkyZCIgeDE9IjM5NS40MiIgeTE9IjY3My40NyIgeDI9IjM5NS40MiIgeTI9IjYwNS40NyIgeGxpbms6aHJlZj0iIzI3NDY1ZjI1LTk0MDgtNDlhOS05MjE2LTQ4YTZjZTljNzBhOCIvPjxsaW5lYXJHcmFkaWVudCBpZD0iZDFlNDAxZmQtNzdiOC00Y2UwLTliYjctNGM3NTkxNGE3NGUzIiB4MT0iOTA4LjkiIHkxPSI0MzAuNTEiIHgyPSI5MDguOSIgeTI9IjI3OSIgeGxpbms6aHJlZj0iIzI3NDY1ZjI1LTk0MDgtNDlhOS05MjE2LTQ4YTZjZTljNzBhOCIvPjxsaW5lYXJHcmFkaWVudCBpZD0iZDRmNTVhNTEtNjY4MS00ZTIwLWFmNjYtNDFkYjU4ZTIzNzhmIiB4MT0iNTQwLjkiIHkxPSIxNTEuNTEiIHgyPSI1NDAuOSIgeTI9IjAiIHhsaW5rOmhyZWY9IiMyNzQ2NWYyNS05NDA4LTQ5YTktOTIxNi00OGE2Y2U5YzcwYTgiLz48bGluZWFyR3JhZGllbnQgaWQ9ImZiYmY2N2NhLWZiZmYtNDE0Mi04NGY4LTUxOGQ5MzY3YzI1YiIgeDE9IjE3OS45IiB5MT0iNjQ1LjUxIiB4Mj0iMTc5LjkiIHkyPSI0OTQiIHhsaW5rOmhyZWY9IiMyNzQ2NWYyNS05NDA4LTQ5YTktOTIxNi00OGE2Y2U5YzcwYTgiLz48L2RlZnM+PHRpdGxlPmNvbGxhYm9yYXRpb24yPC90aXRsZT48ZyBvcGFjaXR5PSIwLjUiPjxwb2x5Z29uIHBvaW50cz0iNzU1LjQxIDgxMC40NyAzMTQuNDIgODEwLjQ3IDMxNC40MiAyMjIuNDcgNjg1LjQyIDIyMi40NyA3NTUuNDEgMjk0LjQ3IDc1NS40MSA4MTAuNDciIGZpbGw9InVybCgjMjc0NjVmMjUtOTQwOC00OWE5LTkyMTYtNDhhNmNlOWM3MGE4KSIvPjwvZz48cG9seWdvbiBwb2ludHM9Ijc1Mi40MSA4MDEuNDcgMzE5LjQyIDgwMS40NyAzMTkuNDIgMjI2LjQ3IDY4NS43NSAyMjYuNDcgNzUyLjQxIDI5MS40NyA3NTIuNDEgODAxLjQ3IiBmaWxsPSIjZmZmIi8+PGcgb3BhY2l0eT0iMC41Ij48cG9seWdvbiBwb2ludHM9IjY4Mi40MSAyOTQuNDcgNjgyLjQxIDIzMC40NyA2ODguMTcgMjMwLjQ3IDc1Mi40MSAyOTQuNDcgNjgyLjQxIDI5NC40NyIgZmlsbD0idXJsKCNlOTEwNDJjYi0yNGVhLTQ1YjctYjExNC02YjFkMDRiYjdmMDgpIi8+PC9nPjxwb2x5Z29uIHBvaW50cz0iNjg1LjQxIDI5MS40NyA2ODUuNDEgMjI2LjQ3IDc1Mi40MSAyOTEuNDcgNjg1LjQxIDI5MS40NyIgZmlsbD0iI2ZhZmFmYSIvPjxnIG9wYWNpdHk9IjAuNSI+PGNpcmNsZSBjeD0iMzk1LjQyIiBjeT0iMzYzLjQ3IiByPSIzNCIgZmlsbD0idXJsKCM5Y2Y4ZTA5OC02ZmFmLTRhNzMtYjgzMS1iYTQyYmEwOTJmMGMpIi8+PC9nPjxjaXJjbGUgY3g9IjM5NS40MiIgY3k9IjM2My40NyIgcj0iMzIiIGZpbGw9IiM2OWYwYWUiLz48ZyBvcGFjaXR5PSIwLjUiPjxjaXJjbGUgY3g9IjM5NS40MiIgY3k9IjUwMS40NyIgcj0iMzQiIGZpbGw9InVybCgjMjFiY2MzZTQtY2QwNS00ZDJlLWI5NWQtOWMyY2JmODkwYTU4KSIvPjwvZz48Y2lyY2xlIGN4PSIzOTUuNDIiIGN5PSI1MDEuNDciIHI9IjMyIiBmaWxsPSIjZTBlMGUwIi8+PGcgb3BhY2l0eT0iMC41Ij48Y2lyY2xlIGN4PSIzOTUuNDIiIGN5PSI2MzkuNDciIHI9IjM0IiBmaWxsPSJ1cmwoIzRkODUzYWZlLWNkY2MtNDg1OC1hOTAwLTgyMGI1MzU3NDkyZCkiLz48L2c+PGNpcmNsZSBjeD0iMzk1LjQyIiBjeT0iNjM5LjQ3IiByPSIzMiIgZmlsbD0iI2UwZTBlMCIvPjxyZWN0IHg9IjQ3NC40MiIgeT0iMzUxLjQ3IiB3aWR0aD0iODYiIGhlaWdodD0iNiIgZmlsbD0iI2UwZTBlMCIvPjxyZWN0IHg9IjQ3NC40MiIgeT0iMzYwLjQ3IiB3aWR0aD0iMTQyIiBoZWlnaHQ9IjYiIGZpbGw9IiNlMGUwZTAiLz48cmVjdCB4PSI0NzQuNDIiIHk9IjM2OS40NyIgd2lkdGg9IjEzMiIgaGVpZ2h0PSI2IiBmaWxsPSIjZTBlMGUwIi8+PHJlY3QgeD0iNDc0LjQyIiB5PSI0ODkuNDciIHdpZHRoPSI4NiIgaGVpZ2h0PSI2IiBmaWxsPSIjZTBlMGUwIi8+PHJlY3QgeD0iNDc0LjQyIiB5PSI0OTguNDciIHdpZHRoPSIxNDIiIGhlaWdodD0iNiIgZmlsbD0iI2UwZTBlMCIvPjxyZWN0IHg9IjQ3NC40MiIgeT0iNTA3LjQ3IiB3aWR0aD0iMTMyIiBoZWlnaHQ9IjYiIGZpbGw9IiNlMGUwZTAiLz48cmVjdCB4PSI0NzQuNDIiIHk9IjYyNy40NyIgd2lkdGg9Ijg2IiBoZWlnaHQ9IjYiIGZpbGw9IiNlMGUwZTAiLz48cmVjdCB4PSI0NzQuNDIiIHk9IjYzNi40NyIgd2lkdGg9IjE0MiIgaGVpZ2h0PSI2IiBmaWxsPSIjZTBlMGUwIi8+PHJlY3QgeD0iNDc0LjQyIiB5PSI2NDUuNDciIHdpZHRoPSIxMzIiIGhlaWdodD0iNiIgZmlsbD0iI2UwZTBlMCIvPjxwb2x5Z29uIHBvaW50cz0iMzgzLjQyIDM2MS40NyAzOTUuNDIgMzcyLjQ3IDQxMi40MiAzNDcuNDcgNDE4LjQyIDM1Mi40NyAzOTUuNDIgMzgyLjQ3IDM3OC40MiAzNjMuNDcgMzgzLjQyIDM2MS40NyIgZmlsbD0iI2ZmZiIvPjxwb2x5Z29uIHBvaW50cz0iMzgzLjQyIDQ5OC40NyAzOTUuNDIgNTA5LjQ3IDQxMi40MiA0ODQuNDcgNDE4LjQyIDQ4OS40NyAzOTUuNDIgNTE5LjQ3IDM3OC40MiA1MDAuNDcgMzgzLjQyIDQ5OC40NyIgZmlsbD0iI2ZmZiIvPjxwb2x5Z29uIHBvaW50cz0iMzgzLjQyIDYzNS40NyAzOTUuNDIgNjQ2LjQ3IDQxMi40MiA2MjEuNDcgNDE4LjQyIDYyNi40NyAzOTUuNDIgNjU2LjQ3IDM3OC40MiA2MzcuNDcgMzgzLjQyIDYzNS40NyIgZmlsbD0iI2ZmZiIvPjxnIG9wYWNpdHk9IjAuNSI+PHJlY3QgeD0iODM3Ljg4IiB5PSIyNzkiIHdpZHRoPSIxNDIuMDQiIGhlaWdodD0iMTUxLjUxIiByeD0iNDEuMDciIHJ5PSI0MS4wNyIgZmlsbD0idXJsKCNkMWU0MDFmZC03N2I4LTRjZTAtOWJiNy00Yzc1OTE0YTc0ZTMpIi8+PC9nPjxyZWN0IHg9Ijg0MS41MSIgeT0iMjgyLjQxIiB3aWR0aD0iMTM0IiBoZWlnaHQ9IjE0Mi45MyIgcng9IjQxLjA3IiByeT0iNDEuMDciIGZpbGw9IiMyNjI2OTkiLz48cGF0aCBkPSJNOTk2LjczLDQyNi43N1Y0MjEuN2EzMiwzMiwwLDEsMC0xNiwwdjUuMDdhMzEuMTIsMzEuMTIsMCwwLDAtMjMsMjkuOTR2MTRoNjJ2LTE0QTMxLjEyLDMxLjEyLDAsMCwwLDk5Ni43Myw0MjYuNzdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtODAuNTYgLTQ0Ljc2KSIgZmlsbD0iI2ZmZiIvPjxjaXJjbGUgY3g9IjkwOC4xNyIgY3k9IjMzOC45NSIgcj0iMzQiIGZpbGw9IiNmZmYiLz48cGF0aCBkPSJNMTAyMi42NCwzODYuMDZzLTEuOTEsMzYuNjUsMTMuMDksNDAuNjVjMCwwLTMxLDE3LTM3LTIwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTgwLjU2IC00NC43NikiIGZpbGw9IiNmZmYiLz48cGF0aCBkPSJNOTU0LjgyLDM4Ni4wNnMxLjkxLDM2LjY1LTEzLjA5LDQwLjY1YzAsMCwzMSwxNywzNy0yMFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04MC41NiAtNDQuNzYpIiBmaWxsPSIjZmZmIi8+PGcgb3BhY2l0eT0iMC41Ij48cmVjdCB4PSI0NjkuODgiIHdpZHRoPSIxNDIuMDQiIGhlaWdodD0iMTUxLjUxIiByeD0iNDEuMDciIHJ5PSI0MS4wNyIgZmlsbD0idXJsKCNkNGY1NWE1MS02NjgxLTRlMjAtYWY2Ni00MWRiNThlMjM3OGYpIi8+PC9nPjxyZWN0IHg9IjQ3My45IiB5PSI0LjI5IiB3aWR0aD0iMTM0IiBoZWlnaHQ9IjE0Mi45MyIgcng9IjQxLjA3IiByeT0iNDEuMDciIGZpbGw9IiMyNjI2OTkiLz48cGF0aCBkPSJNNjY2LjUsMTA1LjYxYy0xLTguNDktMi41LTE3LTUuNzUtMjQuOTRTNjUyLjI4LDY1LjQ0LDY0NSw2MC45MmExOCwxOCwwLDAsMC04LjctM2MtNS42OS0uMi0xMC45NSwzLjY0LTEzLjg4LDguNTJhMzkuNzQsMzkuNzQsMCwwLDAtMi41OSw1LjI3LDEyLjI3LDEyLjI3LDAsMCwwLTEwLjE4LDExLjI0QTMxLjI4LDMxLjI4LDAsMCwwLDYxNC4wOSwxNDJ2NS4zM2EzMS4zOSwzMS4zOSwwLDAsMC0yMy40NSwzMC4yN1YxOTIuMWg2Mi41M1YxNzcuNTlhMzEuMzksMzEuMzksMCwwLDAtMjMuNDUtMzAuMjdWMTQyYTMxLjI4LDMxLjI4LDAsMCwwLDIzLjQ1LTMwLjI4YzAtLjA3LDAtLjE1LDAtLjIybDMuNTIsNy44M2MzLjM1LDcuNDYsNi43OCwxNS40Niw1LjQ3LDIzLjU0QzY2OC41OSwxMzEuODcsNjY4LjA2LDExOC4yNSw2NjYuNSwxMDUuNjFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtODAuNTYgLTQ0Ljc2KSIgZmlsbD0iI2ZmZiIvPjxnIG9wYWNpdHk9IjAuNSI+PHJlY3QgeD0iMTA4Ljg4IiB5PSI0OTQiIHdpZHRoPSIxNDIuMDQiIGhlaWdodD0iMTUxLjUxIiByeD0iNDEuMDciIHJ5PSI0MS4wNyIgZmlsbD0idXJsKCNmYmJmNjdjYS1mYmZmLTQxNDItODRmOC01MThkOTM2N2MyNWIpIi8+PC9nPjxyZWN0IHg9IjExMi45IiB5PSI0OTguMjkiIHdpZHRoPSIxMzQiIGhlaWdodD0iMTQyLjkzIiByeD0iNDEuMDciIHJ5PSI0MS4wNyIgZmlsbD0iIzI2MjY5OSIvPjxwYXRoIGQ9Ik0yMzQuNDUsNjAyLjdhMjMuOTEsMjMuOTEsMCwwLDEtMi42My0xMi40LDE2LjU4LDE2LjU4LDAsMCwxLDUuNDYtMTEuMjVjMy41OS0zLjA2LDguNDYtNC4xNCwxMy4xNi00LjUyczkuNDctLjE1LDE0LjEtMS4wNmEyOS40NywyOS40NywwLDAsMCwxOC44Mi0xMi43NiwzOS42MywzOS42MywwLDAsMS0uMSwxMC44NWMtLjcsMy41Ni0yLjUzLDcuMDYtNS42Miw5LDMuNzQtMS43MywzLjM0LDIuMzMsMi41Miw0Ljc2LDEuODYsMi4yNCw2LjM2LDIuNjEsNi41OSw1LjUxYTE4LjI0LDE4LjI0LDAsMCwxLS45NCw4LjU3Yy0xLjEzLDIuNjcuMDgsNy4zOC0yLjgxLDcuNTkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04MC41NiAtNDQuNzYpIiBmaWxsPSIjZmZmIiBzdHJva2U9IiNmZmYiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPjxwYXRoIGQ9Ik0yNzkuNzgsNTc5LjE2czE2LjQ1LDEuNDMsNC43NCwyNS44NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTgwLjU2IC00NC43NikiIGZpbGw9IiNmZmYiLz48cGF0aCBkPSJNMjY3LjczLDY0Mi43N1Y2MzcuN2EzMiwzMiwwLDEsMC0xNiwwdjUuMDdhMzEuMTIsMzEuMTIsMCwwLDAtMjMsMjkuOTR2MTRoNjJ2LTE0QTMxLjEyLDMxLjEyLDAsMCwwLDI2Ny43Myw2NDIuNzdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtODAuNTYgLTQ0Ljc2KSIgZmlsbD0iI2ZmZiIvPjxsaW5lIHgxPSIxNzguOTIiIHkxPSI0NTEuNDciIHgyPSIxNzguOTIiIHkyPSI0NDUuNDciIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2NmZDhkYyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjIiLz48bGluZSB4MT0iMTc4LjkyIiB5MT0iNDMzLjQ3IiB4Mj0iMTc4LjkyIiB5Mj0iMTAzLjQ3IiBmaWxsPSJub25lIiBzdHJva2U9IiNjZmQ4ZGMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtZGFzaGFycmF5PSIxMiAxMiIvPjxwb2x5bGluZSBwb2ludHM9IjE3OC45MSA5Ny40NyAxNzguOTEgOTEuNDcgMTg0LjkxIDkxLjQ3IiBmaWxsPSJub25lIiBzdHJva2U9IiNjZmQ4ZGMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIyIi8+PGxpbmUgeDE9IjE5Ni43NyIgeTE9IjkxLjQ3IiB4Mj0iNDI3Ljk5IiB5Mj0iOTEuNDciIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2NmZDhkYyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1kYXNoYXJyYXk9IjExLjg2IDExLjg2Ii8+PGxpbmUgeDE9IjQzMy45MiIgeTE9IjkxLjQ3IiB4Mj0iNDM5LjkyIiB5Mj0iOTEuNDciIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2NmZDhkYyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjIiLz48bGluZSB4MT0iNjUxLjkyIiB5MT0iOTEuNDciIHgyPSI2NTcuOTIiIHkyPSI5MS40NyIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjY2ZkOGRjIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMiIvPjxsaW5lIHgxPSI2NjkuNzgiIHkxPSI5MS40NyIgeDI9IjkyNC45OCIgeTI9IjkxLjQ3IiBmaWxsPSJub25lIiBzdHJva2U9IiNjZmQ4ZGMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtZGFzaGFycmF5PSIxMS44NyAxMS44NyIvPjxwb2x5bGluZSBwb2ludHM9IjkzMC45MSA5MS40NyA5MzYuOTEgOTEuNDcgOTM2LjkxIDk3LjQ3IiBmaWxsPSJub25lIiBzdHJva2U9IiNjZmQ4ZGMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIyIi8+PGxpbmUgeDE9IjkzNi45MiIgeTE9IjExMC4yIiB4Mj0iOTM2LjkyIiB5Mj0iMjMxLjExIiBmaWxsPSJub25lIiBzdHJva2U9IiNjZmQ4ZGMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtZGFzaGFycmF5PSIxMi43MyAxMi43MyIvPjxsaW5lIHgxPSI5MzYuOTIiIHkxPSIyMzcuNDciIHgyPSI5MzYuOTIiIHkyPSIyNDMuNDciIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2NmZDhkYyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjIiLz48cmVjdCB4PSI4Mi40MiIgeT0iNTg3LjE3IiB3aWR0aD0iMTAuMTIiIGhlaWdodD0iMTAuMTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIyNy4yNyAtOS4xNikgcm90YXRlKDMwKSIgZmlsbD0iIzY5ZjBhZSIgb3BhY2l0eT0iMC4zIi8+PHJlY3QgeD0iNzgxLjQyIiB5PSI4OS4xNyIgd2lkdGg9IjEwLjEyIiBoZWlnaHQ9IjEwLjEyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3MS45MiAtNDI1LjM4KSByb3RhdGUoMzApIiBmaWxsPSIjNjlmMGFlIiBvcGFjaXR5PSIwLjMiLz48cmVjdCB4PSIzMDAuNDIiIHk9IjczNC4xNyIgd2lkdGg9IjEwLjEyIiBoZWlnaHQ9IjEwLjEyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMjkuOTggLTk4LjQ2KSByb3RhdGUoMzApIiBmaWxsPSIjNGQ4YWYwIiBvcGFjaXR5PSIwLjMiLz48cmVjdCB4PSI4NjkuNDIiIHk9IjI0NC4xNyIgd2lkdGg9IjEwLjEyIiBoZWlnaHQ9IjEwLjEyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNjEuMjEgLTQ0OC42MSkgcm90YXRlKDMwKSIgZmlsbD0iIzRkOGFmMCIgb3BhY2l0eT0iMC4zIi8+PGNpcmNsZSBjeD0iODMxLjkyIiBjeT0iNjY3LjQ3IiByPSI2IiBmaWxsPSIjNjlmMGFlIiBvcGFjaXR5PSIwLjMiLz48Y2lyY2xlIGN4PSIyNjEuOTIiIGN5PSIyNjIuNDciIHI9IjYiIGZpbGw9IiM2OWYwYWUiIG9wYWNpdHk9IjAuMyIvPjxjaXJjbGUgY3g9Ijg3My45MiIgY3k9IjUzMy40NyIgcj0iNiIgZmlsbD0iI2ZmNTI1MiIgb3BhY2l0eT0iMC4zIi8+PHBhdGggZD0iTTExMTUuNDMsODkuNjVoMGEyLjA1LDIuMDUsMCwwLDAsMiwxLjQyaDBhMi4wNSwyLjA1LDAsMCwxLDEuMjEsMy43MWgwYTIuMDUsMi4wNSwwLDAsMC0uNzUsMi4yOWgwYTIuMDUsMi4wNSwwLDAsMS0zLjE2LDIuMjloMGEyLjA1LDIuMDUsMCwwLDAtMi40MSwwaDBhMi4wNSwyLjA1LDAsMCwxLTMuMTYtMi4yOWgwYTIuMDUsMi4wNSwwLDAsMC0uNzUtMi4yOWgwYTIuMDUsMi4wNSwwLDAsMSwxLjIxLTMuNzFoMGEyLjA1LDIuMDUsMCwwLDAsMi0xLjQyaDBBMi4wNSwyLjA1LDAsMCwxLDExMTUuNDMsODkuNjVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtODAuNTYgLTQ0Ljc2KSIgZmlsbD0iI2ZmNTI1MiIgb3BhY2l0eT0iMC4zIi8+PHBhdGggZD0iTTM1MC40Myw1NTYuNjVoMGEyLjA1LDIuMDUsMCwwLDAsMiwxLjQyaDBhMi4wNSwyLjA1LDAsMCwxLDEuMjEsMy43MWgwYTIuMDUsMi4wNSwwLDAsMC0uNzUsMi4yOWgwYTIuMDUsMi4wNSwwLDAsMS0zLjE2LDIuMjloMGEyLjA1LDIuMDUsMCwwLDAtMi40MSwwaDBhMi4wNSwyLjA1LDAsMCwxLTMuMTYtMi4yOWgwYTIuMDUsMi4wNSwwLDAsMC0uNzUtMi4yOWgwYTIuMDUsMi4wNSwwLDAsMSwxLjIxLTMuNzFoMGEyLjA1LDIuMDUsMCwwLDAsMi0xLjQyaDBBMi4wNSwyLjA1LDAsMCwxLDM1MC40Myw1NTYuNjVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtODAuNTYgLTQ0Ljc2KSIgZmlsbD0iI2ZmNTI1MiIgb3BhY2l0eT0iMC4zIi8+PHBhdGggZD0iTTIxNi40MywxMjAuNjVoMGEyLjA1LDIuMDUsMCwwLDAsMiwxLjQyaDBhMi4wNSwyLjA1LDAsMCwxLDEuMjEsMy43MWgwYTIuMDUsMi4wNSwwLDAsMC0uNzUsMi4yOWgwYTIuMDUsMi4wNSwwLDAsMS0zLjE2LDIuMjloMGEyLjA1LDIuMDUsMCwwLDAtMi40MSwwaDBhMi4wNSwyLjA1LDAsMCwxLTMuMTYtMi4yOWgwYTIuMDUsMi4wNSwwLDAsMC0uNzUtMi4yOWgwYTIuMDUsMi4wNSwwLDAsMSwxLjIxLTMuNzFoMGEyLjA1LDIuMDUsMCwwLDAsMi0xLjQyaDBBMi4wNSwyLjA1LDAsMCwxLDIxNi40MywxMjAuNjVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtODAuNTYgLTQ0Ljc2KSIgZmlsbD0iI2ZmNTI1MiIgb3BhY2l0eT0iMC4zIi8+PHBhdGggZD0iTTUxMS40Myw1My42NWgwYTIuMDUsMi4wNSwwLDAsMCwyLDEuNDJoMGEyLjA1LDIuMDUsMCwwLDEsMS4yMSwzLjcxaDBhMi4wNSwyLjA1LDAsMCwwLS43NSwyLjI5aDBhMi4wNSwyLjA1LDAsMCwxLTMuMTYsMi4yOWgwYTIuMDUsMi4wNSwwLDAsMC0yLjQxLDBoMGEyLjA1LDIuMDUsMCwwLDEtMy4xNi0yLjI5aDBhMi4wNSwyLjA1LDAsMCwwLS43NS0yLjI5aDBhMi4wNSwyLjA1LDAsMCwxLDEuMjEtMy43MWgwYTIuMDUsMi4wNSwwLDAsMCwyLTEuNDJoMEEyLjA1LDIuMDUsMCwwLDEsNTExLjQzLDUzLjY1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTgwLjU2IC00NC43NikiIGZpbGw9IiM0ZDhhZjAiIG9wYWNpdHk9IjAuMyIvPjxwYXRoIGQ9Ik0xMDY4LjQzLDMzMS42NWgwYTIuMDUsMi4wNSwwLDAsMCwyLDEuNDJoMGEyLjA1LDIuMDUsMCwwLDEsMS4yMSwzLjcxaDBhMi4wNSwyLjA1LDAsMCwwLS43NSwyLjI5aDBhMi4wNSwyLjA1LDAsMCwxLTMuMTYsMi4yOWgwYTIuMDUsMi4wNSwwLDAsMC0yLjQxLDBoMGEyLjA1LDIuMDUsMCwwLDEtMy4xNi0yLjI5aDBhMi4wNSwyLjA1LDAsMCwwLS43NS0yLjI5aDBhMi4wNSwyLjA1LDAsMCwxLDEuMjEtMy43MWgwYTIuMDUsMi4wNSwwLDAsMCwyLTEuNDJoMEEyLjA1LDIuMDUsMCwwLDEsMTA2OC40MywzMzEuNjVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtODAuNTYgLTQ0Ljc2KSIgZmlsbD0iIzRkOGFmMCIgb3BhY2l0eT0iMC4zIi8+PC9zdmc+"

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/undraw_newsletter_vovu.021b9d94.svg";

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(27);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactstrap = __webpack_require__(13);
	
	var _undraw_collaboration2_8og = __webpack_require__(489);
	
	var _undraw_collaboration2_8og2 = _interopRequireDefault(_undraw_collaboration2_8og);
	
	var _undraw_newsletter_vovu = __webpack_require__(139);
	
	var _undraw_newsletter_vovu2 = _interopRequireDefault(_undraw_newsletter_vovu);
	
	var _profile = __webpack_require__(76);
	
	var _profile2 = _interopRequireDefault(_profile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function encode(data) {
	  return Object.keys(data).map(function (key) {
	    return encodeURIComponent(key) + "=" + encodeURIComponent(data[key]);
	  }).join("&");
	}
	
	var KontaktPage = function (_React$Component) {
	  _inherits(KontaktPage, _React$Component);
	
	  function KontaktPage(props) {
	    _classCallCheck(this, KontaktPage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleChange = function (e) {
	      var _this$setState;
	
	      var name = e.target.name;
	      var touchedName = name + 'Touched';
	      var value = e.target.value;
	      _this.setState((_this$setState = {}, _this$setState[name] = value, _this$setState[touchedName] = true, _this$setState), function () {
	        _this.validateField(name, value);
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	
	      fetch("/", {
	        method: "POST",
	        headers: { "Content-Type": "application/x-www-form-urlencoded" },
	        body: encode(_extends({ "form-name": "contact" }, _this.state))
	      }).then(function () {
	        return (0, _gatsbyLink.navigateTo)('/kontakt-danke');
	      }).catch(function (error) {
	        return alert(error);
	      });
	    };
	
	    _this.state = {
	      company: '',
	      email: '',
	      message: '',
	      budget: '',
	      formErrors: { company: '', email: '' },
	      companyTouched: false,
	      emailTouched: false,
	      emailValid: false,
	      companyValid: false,
	      formValid: false
	    };
	    return _this;
	  }
	
	  KontaktPage.prototype.validateField = function validateField(fieldName, value) {
	    var emailValid = this.state.emailValid;
	    var companyValid = this.state.companyValid;
	
	    switch (fieldName) {
	      case 'email':
	        emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
	        break;
	      case 'company':
	        companyValid = value.length >= 1;
	        break;
	      default:
	        break;
	    }
	
	    this.setState({
	      emailValid: emailValid,
	      companyValid: companyValid
	    }, this.validateForm);
	  };
	
	  KontaktPage.prototype.validateForm = function validateForm() {
	    this.setState({ formValid: this.state.emailValid && this.state.companyValid });
	  };
	
	  KontaktPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: 'Senden Sie mir Ihre Projektanfragen oder kontaktieren Sie mich telefonisch.',
	        meta: [{ name: 'description', content: 'Ich freue mich von Ihren Ideen und Projekten zu hören. Bitte teilen Sie mir noch ein paar Eckdaten mit oder kontaktieren Sie mich telefonisch oder via E-Mail.' }, { name: 'keywords', content: 'software engineering, softwareentwicklung, Weibern, Haag am Hausruck, Linz, Wels, Grieskirchen, Oberösterreich' }]
	      }),
	      _react2.default.createElement(
	        'section',
	        { className: 'sls-block border-bottom bg evelope' },
	        _react2.default.createElement('div', { className: 'bg-image left-40 d-none d-md-block', style: { backgroundImage: 'url(' + _undraw_collaboration2_8og2.default + ')', backgroundSize: 'contain' } }),
	        _react2.default.createElement(
	          _reactstrap.Container,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'align-items-center py-5 py-lg-7 justify-content-end ' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { md: '7' },
	              _react2.default.createElement(
	                'h1',
	                null,
	                'Kontakt aufnehmen.'
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'lead my-5' },
	                'Ich freue mich von Ihren Ideen und Projekten zu h\xF6ren. Bitte teilen Sie mir noch ein paar Eckdaten mit.'
	              ),
	              _react2.default.createElement(
	                _reactstrap.Form,
	                { method: 'post', name: 'contact', 'data-netlify': 'true', 'data-netlify-honeypot': 'bot-field', onSubmit: this.handleSubmit },
	                _react2.default.createElement(
	                  'p',
	                  { hidden: true },
	                  _react2.default.createElement(
	                    'label',
	                    null,
	                    'Bitte dies freilassen. ',
	                    _react2.default.createElement('input', { name: 'bot-field', onChange: this.handleChange })
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.FormGroup,
	                  null,
	                  _react2.default.createElement(
	                    _reactstrap.Label,
	                    { 'for': 'company', className: 'text-uppercase h6' },
	                    'Firma oder Projektname *'
	                  ),
	                  _react2.default.createElement(_reactstrap.Input, { type: 'text', name: 'company', id: 'company', onChange: this.handleChange, value: this.state.company, invalid: this.state.companyTouched && !this.state.companyValid }),
	                  this.state.companyTouched && !this.state.companyValid && _react2.default.createElement(
	                    _reactstrap.FormFeedback,
	                    null,
	                    'Dieses Feld bitte ausf\xFCllen.'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.FormGroup,
	                  null,
	                  _react2.default.createElement(
	                    _reactstrap.Label,
	                    { 'for': 'email', className: 'text-uppercase h6' },
	                    'Ihre E-Mail Adresse *'
	                  ),
	                  _react2.default.createElement(_reactstrap.Input, { type: 'email', name: 'email', id: 'email', onChange: this.handleChange, value: this.state.email, invalid: this.state.emailTouched && !this.state.emailValid }),
	                  this.state.emailTouched && !this.state.emailValid && _react2.default.createElement(
	                    _reactstrap.FormFeedback,
	                    null,
	                    'Die Email-Adresse ist ung\xFCltig.'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.FormGroup,
	                  null,
	                  _react2.default.createElement(
	                    _reactstrap.Label,
	                    { 'for': 'message', className: 'text-uppercase h6' },
	                    'Ihre Nachricht'
	                  ),
	                  _react2.default.createElement(_reactstrap.Input, { type: 'textarea', name: 'message', id: 'message', rows: '4', onChange: this.handleChange, value: this.state.message })
	                ),
	                _react2.default.createElement(
	                  _reactstrap.FormGroup,
	                  null,
	                  _react2.default.createElement(
	                    _reactstrap.Label,
	                    { 'for': 'budget', className: 'text-uppercase h6' },
	                    'Welchen Budgetrahmen haben Sie sich gesetzt?'
	                  ),
	                  _react2.default.createElement(_reactstrap.Input, { type: 'text', name: 'budget', id: 'budget', onChange: this.handleChange, value: this.state.budget })
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'small' },
	                  'Die angegebenen Daten werden vertraulich behandelt und zum Zweck der Kontaktaufnahme auf unserem Server gespeichert aber niemals f\xFCr andere Zwecke verwendet.'
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Button,
	                  { type: 'submit', color: 'primary', disabled: !this.state.formValid },
	                  'Absenden'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          _reactstrap.Container,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Row,
	            { className: 'align-items-center py-5 py-lg-7' },
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { md: '7', lg: '6' },
	              _react2.default.createElement(
	                _reactstrap.Row,
	                { className: 'align-items-center mb-6' },
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { xs: '3' },
	                  _react2.default.createElement(_profile2.default, null)
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { xs: '9' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'lead p-0 m-0' },
	                    'Sie k\xF6nnen mich auch gerne anrufen oder mir eine E-Mail senden.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactstrap.Row,
	                null,
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { xs: '6' },
	                  _react2.default.createElement(
	                    'h5',
	                    { className: 'text-uppercase mt-md-4' },
	                    'Telefon'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    '+43 664 14 555 90'
	                  ),
	                  _react2.default.createElement(
	                    'h5',
	                    { className: 'text-uppercase mt-md-4' },
	                    'E-Mail'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                      'a',
	                      { href: 'mailto:thomas@schmidleithner.at' },
	                      'thomas@schmidleithner.at'
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactstrap.Col,
	                  { xs: '6' },
	                  _react2.default.createElement(
	                    'h5',
	                    { className: 'text-uppercase mt-md-4' },
	                    'Adresse'
	                  ),
	                  _react2.default.createElement(
	                    'address',
	                    null,
	                    'Grolzham 2D',
	                    _react2.default.createElement('br', null),
	                    '4680 Weibern',
	                    _react2.default.createElement('br', null),
	                    'Austria'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { md: '5', lg: '6' },
	              _react2.default.createElement('img', { src: _undraw_newsletter_vovu2.default, className: 'img-fluid p-6', alt: 'Kontakt' })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return KontaktPage;
	}(_react2.default.Component);
	
	exports.default = KontaktPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-kontakt-js-123c6734a437af24decf.js